import React from 'react';
import VariousLogoSVG from '../svg/various-logos.svg';

export default React.memo(function VariousLogos() {
  return (
    <div className="flex items-center justify-center mt-6">
      <img src={VariousLogoSVG} alt="various logos" className="size-full" />
    </div>
  );
});
